import index from "./mainMenu.vue";
export default index;
